import { Box, Skeleton, Typography } from "@mui/material";
import { COLORS } from "../../../ui/Theme";
import { useTicketContext } from "../../../context/ticket/TicketContext";
import { Link, useParams, useSearchParams } from "react-router-dom";
import TicketLables from "../TicketLables";
import NotFound from "../../../components/notfound/NotFound";

const TicketsList = () => {
  const { filteredTickets, isLoading } = useTicketContext();
  const { ticketId } = useParams();
  const [searchParams] = useSearchParams();

  if (isLoading)
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          gap: "20px",
        }}
      >
        {Array.from({ length: 4 }).map((_, index) => (
          <Skeleton key={index} height="120px" variant="rounded" />
        ))}
      </Box>
    );

  if (filteredTickets.length < 1) return <NotFound />;
  else
    return (
      <Box
        sx={{
          overflowY: "scroll",
          scrollbarWidth: "none",
          position: "relative",
          pb: 1,
          "&::-webkit-scrollbar": {
            display: "none",
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            gap: "10px",
          }}
        >
          {filteredTickets?.map((ticket) => (
            <Link
              to={{
                pathname: `${ticket.id}`,
                search: searchParams.toString(),
              }}
              key={ticket.id}
            >
              <Box
                key={ticket.id}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  gap: "14px",
                  padding: "10px",
                  border: `1px solid ${
                    ticketId === String(ticket.id) ? COLORS.BLUE : "#eee"
                  }`,
                  borderRadius: "12px",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Typography sx={{ fontWeight: 900, fontSize: "16px" }}>
                    {ticket.title}
                  </Typography>
                  <Typography sx={{ color: COLORS.GRAY, fontSize: "12px" }}>
                    {ticket.last_update}
                  </Typography>
                </Box>
                <Typography sx={{ fontSize: "12px" }}>
                  {ticket.text.slice(0, 50)}...
                </Typography>

                <TicketLables data={ticket} />
              </Box>
            </Link>
          ))}
        </Box>
      </Box>
    );
};

export default TicketsList;
